import type { JSX } from "solid-js";
import { For, Show } from "solid-js";

type ScanBreadcrumbItem = {
  label: string;
  href?: string;
};

export function ScanRouteSurface(props: {
  children: JSX.Element;
  class?: string;
}) {
  return (
    <div class={`signal-route-surface${props.class ? ` ${props.class}` : ""}`}>
      {props.children}
    </div>
  );
}

export function ScanBreadcrumbs(props: { items: ScanBreadcrumbItem[] }) {
  return (
    <nav class="signal-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        <For each={props.items}>
          {(item, index) => {
            const current = () => index() === props.items.length - 1;
            return (
              <li aria-current={current() ? "page" : undefined}>
                <Show
                  when={item.href && !current()}
                  fallback={<span>{item.label}</span>}
                >
                  <a href={item.href}>{item.label}</a>
                </Show>
              </li>
            );
          }}
        </For>
      </ol>
    </nav>
  );
}
